// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"RefinementSearchInput_inputWrapper__D62Nj","dropdownInputField":"RefinementSearchInput_dropdownInputField__zulaq","close":"RefinementSearchInput_close__Kwi2p"};